/* EGO Capture page behaviour (bobovr-ego-* sections).
   Ported from ego-capture-page/08-site/assets/ego.js. The landing, inquiry and
   thanks views are separate Shopify pages here, so each part runs only when its
   elements are on the page. */
(function () {
  'use strict';

  var SUMMARY_KEY = 'ego-inquiry-summary';
  var DRAFT_KEY = 'ego-inquiry-draft';

  // ---------- Sticky bars (phone; hidden by CSS on wider screens) ----------
  var stick = document.querySelector('[data-stick]');
  var stickForm = document.querySelector('[data-stick-form]');
  var hero = document.querySelector('.ego-hero');
  var contact = document.querySelector('.ego-contact');
  var stickQueued = false;
  var sending = false;

  function updateStick() {
    stickQueued = false;
    // Landing: between the hero CTA leaving the screen and the contact CTA arriving.
    if (stick && hero && contact) {
      stick.classList.toggle('is-on', hero.getBoundingClientRect().bottom < 0 &&
        contact.getBoundingClientRect().top > window.innerHeight);
    }
    if (!form || !stickForm) return;
    // Form: once every required field has an answer, until the real button is on screen.
    var ready = !sending &&
      Array.prototype.every.call(form.querySelectorAll('[required]'), function (f) { return f.value.trim(); }) &&
      form.querySelector('.ego-submit').getBoundingClientRect().top > window.innerHeight;
    stickForm.classList.toggle('is-on', ready);
  }
  window.addEventListener('scroll', function () {
    if (!stickQueued) { stickQueued = true; requestAnimationFrame(updateStick); }
  }, { passive: true });

  var form = document.getElementById('ego-inquiry');
  updateStick();

  // ---------- Thanks page: summary of what was sent ----------
  var receiptBox = document.querySelector('.ego-receipt');
  if (receiptBox) {
    receiptBox.addEventListener('toggle', function () {
      receiptBox.querySelector('.ego-receipt__more').textContent = receiptBox.open ? 'Hide' : 'Show what you sent';
    });
    renderSummary();
  }

  if (!form) return; // everything below is the inquiry form

  // ---------- Validation ----------
  var EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
  var MESSAGES = {
    name: 'Please enter your name.',
    email: 'Please enter your work email.',
    emailFormat: 'Please enter a valid email address, like you@company.com.',
    company: 'Please enter your company or lab.',
    task: 'Please describe the task you\'re collecting for.'
  };

  function setError(field, message) {
    var label = field.closest('.ego-field');
    var err = label.querySelector('.ego-err');
    var base = field.dataset.describedby;
    if (base === undefined) base = field.dataset.describedby = field.getAttribute('aria-describedby') || '';
    if (!message) {
      field.removeAttribute('aria-invalid');
      if (base) field.setAttribute('aria-describedby', base); else field.removeAttribute('aria-describedby');
      if (err) err.remove();
      return;
    }
    if (!err) {
      err = document.createElement('p');
      err.className = 'ego-err';
      err.id = 'ego-err-' + field.name;
      label.appendChild(err);
      field.setAttribute('aria-describedby', (base + ' ' + err.id).trim());
    }
    field.setAttribute('aria-invalid', 'true');
    err.textContent = message;
  }

  var LABELS = { name: 'Name', email: 'Work email', company: 'Company or lab', task: 'The task' };
  var formError = form.querySelector('[data-form-error]');
  var summaryShown = false;

  // Error summary above the form: one link per field that is empty or invalid.
  function showErrorSummary(invalid) {
    summaryShown = invalid.length > 0;
    if (!summaryShown) { formError.hidden = true; return; }
    formError.textContent = invalid.length === 1 ? '1 field needs attention:' : invalid.length + ' fields need attention:';
    var ul = document.createElement('ul');
    invalid.forEach(function (f) {
      var li = document.createElement('li');
      var a = document.createElement('a');
      a.href = '#';
      a.textContent = LABELS[f.name];
      a.addEventListener('click', function (e) { e.preventDefault(); f.focus(); });
      li.appendChild(a);
      ul.appendChild(li);
    });
    formError.appendChild(ul);
    formError.hidden = false;
  }

  function refreshErrorSummary() {
    if (!summaryShown) return;
    showErrorSummary(Array.prototype.filter.call(form.querySelectorAll('[required][aria-invalid]'), function () { return true; }));
  }

  function check(field) {
    var value = field.value.trim();
    if (!field.required) return true;
    if (!value) { setError(field, MESSAGES[field.name]); return false; }
    if (field.type === 'email' && !EMAIL.test(value)) { setError(field, MESSAGES.emailFormat); return false; }
    setError(field, null);
    return true;
  }

  form.querySelectorAll('[required]').forEach(function (field) {
    // Validate on leaving a field; once flagged, clear the error as soon as it is fixed.
    field.addEventListener('blur', function () { if (field.value.trim()) check(field); });
    field.addEventListener('input', function () { if (field.hasAttribute('aria-invalid')) { check(field); refreshErrorSummary(); } });
  });

  // ---------- Optional single choices can be cleared by choosing them again ----------
  form.addEventListener('pointerdown', function (e) {
    var label = e.target.closest('label');
    var input = label && label.querySelector('input[type="radio"]');
    if (input) input.dataset.was = input.checked ? '1' : '';
  });
  form.addEventListener('click', function (e) {
    var input = e.target;
    if (input.type !== 'radio' || input.dataset.was !== '1') return;
    input.dataset.was = '';
    input.checked = false;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  // ---------- Draft: keep what was typed if the visitor leaves and comes back ----------
  function saveDraft() {
    var draft = {};
    Array.prototype.forEach.call(form.elements, function (el) {
      if (!el.name || el.name === 'website') return;
      if (el.type === 'radio' || el.type === 'checkbox') {
        if (!el.checked) return;
        (draft[el.name] = draft[el.name] || []).push(el.value);
      } else if (el.value) {
        draft[el.name] = el.value;
      }
    });
    try { sessionStorage.setItem(DRAFT_KEY, JSON.stringify(draft)); } catch (err) { /* draft is a convenience */ }
  }

  function restoreDraft() {
    var draft = null;
    try { draft = JSON.parse(sessionStorage.getItem(DRAFT_KEY) || 'null'); } catch (err) { /* ignore */ }
    if (!draft || !Object.keys(draft).length) return;
    draftNote.hidden = false;
    Array.prototype.forEach.call(form.elements, function (el) {
      if (!el.name || !(el.name in draft)) return;
      if (el.type === 'radio' || el.type === 'checkbox') el.checked = draft[el.name].indexOf(el.value) !== -1;
      else el.value = draft[el.name];
    });
  }

  var draftNote = form.querySelector('[data-draft]');
  restoreDraft();
  form.addEventListener('input', saveDraft);
  form.addEventListener('change', saveDraft);
  form.addEventListener('input', updateStick);
  draftNote.querySelector('[data-draft-clear]').addEventListener('click', function () {
    form.reset();
    form.querySelectorAll('[aria-invalid]').forEach(function (f) { setError(f, null); });
    showErrorSummary([]);
    try { sessionStorage.removeItem(DRAFT_KEY); } catch (err) { /* ignore */ }
    draftNote.hidden = true;
    updateStick();
    form.querySelector('[name="name"]').focus();
  });

  // ---------- Submit ----------
  function collect() {
    var data = new FormData(form);
    return {
      name: (data.get('name') || '').trim(),
      email: (data.get('email') || '').trim(),
      company: (data.get('company') || '').trim(),
      task: (data.get('task') || '').trim(),
      workspace: data.get('workspace') || '',
      operators: data.get('operators') || '',
      timeline: data.get('timeline') || '',
      priorities: data.getAll('priorities'),
      wrist: data.get('wrist') || '',
      website: data.get('website') || '',
      page: location.pathname,
      source: source(),
      submittedAt: new Date().toISOString()
    };
  }

  // Where the visitor came from, for the inquiry record: the site the tab entered the store from, its first page there and that
  // page's UTM tags (theme snippets/bobovr-entry.liquid keeps them in sessionStorage), and the page before this one.
  function source() {
    var e = {}, prev = '', site = function (h) { return h.replace(/^www\./, ''); };
    try { e = JSON.parse(sessionStorage.getItem('bobovr-entry') || '{}') || {}; } catch (err) { /* storage blocked */ }
    try { var u = new URL(document.referrer); prev = site(u.hostname) === site(location.hostname) ? u.pathname : site(u.hostname); } catch (err) { /* none */ }
    return { entry: e.ref || '', entryPage: e.page || '', utm: e.utm || '', prev: prev };
  }

  // What the visitor saw, for the confirmation page (the payload keeps the contract values).
  function picked(name) {
    return Array.prototype.filter.call(form.querySelectorAll('[name="' + name + '"]'), function (i) { return i.checked; })
      .map(function (i) { return i.closest('label').textContent.trim(); });
  }
  function receipt(payload) {
    return [
      ['Reply to', payload.email],
      ['Task', payload.task],
      ['Hands work', picked('workspace').join('')],
      ['Wrist cameras', picked('wrist').join('')],
      ['Operators', picked('operators').join('')],
      ['Start', picked('timeline').join('')],
      ['Matters most', picked('priorities').join(' · ')]
    ].filter(function (r) { return r[1]; });
  }

  // ---------- Turnstile ----------
  // Local previews use Cloudflare's always-pass test key; the real key only
  // works on the hostnames registered for the widget (bobovr.com).
  var LOCAL = /^(localhost|127\.0\.0\.1)$/.test(location.hostname);
  var TURNSTILE_SITEKEY = LOCAL ? '1x00000000000000000000AA' : '0x4AAAAAAFaMebi93OrCE0t4';
  var captcha = form.querySelector('[data-turnstile]');
  var captchaId = null;
  // Shown only when the widget fails (blocked network, privacy browser, failed check):
  // an email route so the visitor is never stuck. Hidden again once a check passes.
  var captchaHelp = document.createElement('p');
  captchaHelp.className = 'ego-note ego-captcha-help';
  captchaHelp.hidden = true;
  captchaHelp.innerHTML = 'Verification not working? Email us at <a href="mailto:support@bobovr.com">support@bobovr.com</a>.';
  captcha.parentNode.insertBefore(captchaHelp, captcha.nextSibling);
  function captchaFailed() { captchaHelp.hidden = false; }
  // the Turnstile script itself may be blocked (ad blockers, some networks): then it never calls back
  setTimeout(function () { if (captchaId === null) captchaFailed(); }, 10000);
  window.egoTurnstileReady = function () {
    captchaId = window.turnstile.render(captcha, {
      sitekey: TURNSTILE_SITEKEY, theme: 'light', size: 'flexible', language: 'en',
      callback: function () { captchaHelp.hidden = true; },
      'error-callback': captchaFailed,
      'unsupported-callback': captchaFailed,
    });
  };
  function captchaToken() {
    return captchaId !== null ? window.turnstile.getResponse(captchaId) || '' : '';
  }
  function resetCaptcha() {
    if (captchaId !== null) window.turnstile.reset(captchaId);
  }

  // Cloudflare Worker in ego-capture-page/09-relay: validates, checks Turnstile, writes the Feishu Bitable.
  // Reached through the store's own address, the Shopify app proxy "EGO inquiry relay" (ego-capture-page/10-shopify-app),
  // so the form works wherever the store opens: the Worker's workers.dev address does not open in mainland China.
  // A 404 there means the proxy is gone (app uninstalled): then the Worker directly.
  var RELAY_URL = '/apps/ego-relay';
  var RELAY_DIRECT = 'https://ego-inquiry-relay.bobovr.workers.dev';

  // The relay gives up on Turnstile and Feishu within about 23 s; past 30 s the visitor gets the error box and can retry or email.
  var SEND_TIMEOUT = 30000;

  function submitInquiry(payload) {
    payload.turnstile = captchaToken();
    var ac = window.AbortController ? new AbortController() : null;
    var timer = ac && setTimeout(function () { ac.abort(); }, SEND_TIMEOUT);
    var send = function (url) {
      return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload), signal: ac ? ac.signal : undefined });
    };
    return send(RELAY_URL)
      .then(function (r) { return r.status === 404 ? send(RELAY_DIRECT) : r; })
      .then(function (r) { clearTimeout(timer); if (!r.ok) throw new Error('HTTP ' + r.status); },
        function (err) { clearTimeout(timer); throw err; });
  }

  // ---------- Conversion event ----------
  // GA4 (gtag is on every storefront page) gets the recommended generate_lead event;
  // Shopify web pixels get a custom event. Only the optional choices go out, never
  // the name, email, company or task. Waits at most a second, then moves on.
  function trackLead(payload, next) {
    var done = false;
    function go() { if (!done) { done = true; next(); } }
    var params = {
      form_id: 'ego_inquiry',
      workspace: payload.workspace || '(none)',
      wrist: payload.wrist || '(none)',
      operators: payload.operators || '(none)',
      timeline: payload.timeline || '(none)',
      priorities_count: payload.priorities.length
    };
    try {
      if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish('ego_inquiry_submitted', params);
    } catch (err) { /* analytics must never block the visitor */ }
    try {
      if (typeof window.gtag === 'function') {
        window.gtag('event', 'generate_lead', Object.assign({ event_callback: go, event_timeout: 1000 }, params));
        setTimeout(go, 1200);
        return;
      }
    } catch (err) { /* fall through */ }
    go();
  }

  var button = form.querySelector('button[type="submit"]');

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    formError.hidden = true;

    var invalid = Array.prototype.filter.call(form.querySelectorAll('[required]'), function (f) { return !check(f); });
    showErrorSummary(invalid);
    if (invalid.length) { invalid[0].focus(); return; }

    var payload = collect();
    if (payload.website) { location.href = form.dataset.thanksUrl; return; } // honeypot: pretend success
    if (!captchaToken()) {
      formError.textContent = 'Please complete the verification above the button, then send again. If it won\'t load, email support@bobovr.com.';
      formError.hidden = false;
      captcha.scrollIntoView({ block: 'center' });
      return;
    }

    var rows = receipt(payload);
    sending = true;
    updateStick();
    button.disabled = true;
    button.innerHTML = '<span class="ego-spin" aria-hidden="true"></span>Sending…';
    submitInquiry(payload).then(function () {
      try {
        sessionStorage.setItem(SUMMARY_KEY, JSON.stringify(rows));
        sessionStorage.removeItem(DRAFT_KEY);
      } catch (err) { /* summary just stays empty */ }
      form.reset();
      draftNote.hidden = true;
      trackLead(payload, function () { location.href = form.dataset.thanksUrl; });
    }).catch(function () {
      formError.innerHTML = 'Your inquiry could not be sent. Please try again, or email us at <a href="mailto:support@bobovr.com">support@bobovr.com</a>.';
      formError.hidden = false;
      formError.scrollIntoView({ block: 'center' });
    }).then(function () {
      resetCaptcha(); // a Turnstile token is single-use
      sending = false;
      button.disabled = false;
      button.textContent = 'Send inquiry';
    });
  });

  // Hoisted: the thanks page calls this before the form code returns early.
  function renderSummary() {
    var dl = document.querySelector('[data-summary]');
    var rows = null;
    try { rows = JSON.parse(sessionStorage.getItem(SUMMARY_KEY) || 'null'); } catch (err) { /* ignore */ }
    if (!Array.isArray(rows)) rows = [];

    dl.textContent = '';
    rows.forEach(function (r) {
      var row = document.createElement('div');
      var dt = document.createElement('dt');
      var dd = document.createElement('dd');
      dt.textContent = r[0];
      dd.textContent = r[1];
      row.append(dt, dd);
      dl.appendChild(row);
    });
    var receiptEl = dl.closest('details');
    receiptEl.open = false;
    receiptEl.querySelector('[data-receipt-line]').textContent =
      rows[0] ? 'We\'ll reply to ' + rows[0][1] : 'Your inquiry';
    // Opened directly without submitting: hide the receipt rather than show it empty.
    receiptEl.hidden = rows.length === 0;
  }

})();
